import { ObjectRequest } from '../interfaces';
import isAllowedManifestUrl from './isAllowedManifestUrl';
import isAllowedRangeRequest from './isAllowedRangeRequest';

export default function isAllowedLocalAgentRequest(
  app: string,
  request: ObjectRequest
): boolean {
  const { headers, url } = request;
  return isAllowedRangeRequest(app, headers) && isAllowedManifestUrl(app, url);
}
